module.exports = __webpack_public_path__ + "a3dfc27ed4c1f258008f6e281a8f07f1.png";